<form [formGroup]="formData" novalidate>
  <div class="container">
    <div class="kt-portlet kt-portlet--responsive-mobile">
      <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
          <h2 class="kt-portlet__head-title text-capitalize">
            <span> {{ pageTitle }} </span>
          </h2>
        </div>
        <div class="kt-portlet__head-toolbar">
          <button
            *ngIf="!isModal"
            class="btn btn-default mr-2 no-iframe"
            type="button"
            [routerLink]="['/orders']"
          >
            <i class="fas fa-arrow-left"></i> Go back to Purchase Orders
          </button>
          <button
            *ngIf="isModal"
            class="btn btn-default mr-2 no-iframe"
            type="button"
            (click)="dialogRef.close()"
          >
            <i class="fa fa-times"></i> Close
          </button>
        </div>
      </div>
      <div class="kt-portlet__body" *ngIf="!isPageLoad">
        <mat-tab-group
          (selectedTabChange)="onTabChanged($event)"
          mat-align-tabs="center"
          dynamicHeight
          [selectedIndex]="activeTab"
        >
          <mat-tab label="Set Purchase Order Details">
            <div class="row">
              <div class="col-md-10">
                <div class="form-group" *ngIf="factory$ | async as factories">
                  <label for="">Choose Supplier</label>
                  <ng-select
                    [items]="factories"
                    bindLabel="factory_name"
                    bindValue="id"
                    formControlName="factory_id"
                    [multiple]="false"
                    (change)="getFactoryRfqs()"
                  >
                  </ng-select>
                </div>
              </div>

              <div class="col-md-2 align-self-center">
                <button
                  class="btn btn-outline-info btn-sm"
                  *ngIf="authLoginUserPrwx === 7"
                  type="button"
                  mat-raised-button
                  color="primary"
                  matTooltip="New"
                  (click)="createNew()"
                  [ngClass]="{
                    'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':
                      loading,
                  }"
                >
                  <i class="fas fa-plus"></i> Add New Supplier
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="">Order Type</label>
                  <select
                    class="form-control"
                    *ngIf="!purchaseOrder"
                    formControlName="order_type"
                  >
                    <option value="1">Bulk Order</option>
                    <option value="10">Sample Order</option>
                  </select>
                  <span class="form-control" *ngIf="purchaseOrder">
                    <p *ngIf="purchaseOrder.order_type == 1">Bulk Order</p>
                    <p *ngIf="purchaseOrder.order_type == 10">Sample Order</p>
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <label for="">Incoterm</label>
                <select
                  formControlName="logistic"
                  class="form-control"
                  (change)="reset()"
                >
                  <option *ngFor="let l of logistics | keyvalue" [value]="l.key">
                    {{ l.value }}
                  </option>
                </select>
              </div>
              <div class="col-md-4" *ngIf="showIntlShipping">
                <label for="">Intl Shipping</label>
                <select formControlName="intl_shippping" class="form-control">
                  <option value="sea">SEA</option>
                  <option value="air">AIR</option>
                </select>
              </div>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="">Payment Terms</label>
                  <select formControlName="payment_terms" class="form-control">
                    <option *ngFor="let pt of paymentTerms" [value]="pt.label">
                      {{ pt.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-md-8">
                <div class="form-group">
                  <label for="">Tracking Info</label>
                  <input
                    type="text"
                    class="form-control"
                    formControlName="tracking_info"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label for="">Order Date</label>
                  <input
                    type="date"
                    class="form-control"
                    formControlName="order_date"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="">Requested Ship Date</label>
                  <input
                    type="date"
                    class="form-control"
                    formControlName="requested_ship_date"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="">Arrival Due Date</label>
                  <input
                    type="date"
                    class="form-control"
                    formControlName="arrival_due_date"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="">Invoice Date</label>
                  <input
                    type="date"
                    class="form-control"
                    formControlName="invoice_date"
                  />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-8">
                <div class="form-group">
                  <label for="">Alternate ID</label>
                  <ng-select
                    [items]="alternateIds"
                    [addTag]="true"
                    [(ngModel)]="alternateIds"
                    [ngModelOptions]="{ standalone: true }"
                    multiple="true"
                    [hideSelected]="true"
                  ></ng-select>
                </div>
              </div>
            </div>

            <div class="form-group">
              <label for="">Private Note</label>
              <textarea
                atMention
                [atMentionItems]="staff"
                type="text"
                class="form-control note"
                formControlName="private_note"
              ></textarea>
            </div>

            <div class="form-group">
              <label for="">Public Note</label>
              <textarea
                atMention
                [atMentionItems]="staff"
                type="text"
                class="form-control note"
                formControlName="public_note"
              ></textarea>
            </div>

            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label for="">Default Ship to Address</label>
                  <select
                    formControlName="default_ship_to_address"
                    class="form-control"
                    (change)="changeDefaultShipTo($event.target.value)"
                  >
                    <option
                      *ngFor="let sta of shipToAddressLookUp"
                      [value]="sta.value"
                    >
                      {{ sta.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="col-md-4"
                *ngIf="
                  formData.controls.default_ship_to_address.value == 'warehouse'
                "
              >
                <div class="form-group">
                  <label>Select a Warehouse: </label>
                  <select
                    class="form-control"
                    formControlName="warehouse_id"
                    (change)="changeWarehouse($event.target.value)"
                  >
                    <option [value]="default_warehouse_id"></option>
                    <option *ngFor="let w of warehouses" [value]="w.id">
                      {{ w.location_name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Client</label>
                  <ng-select
                    [items]="client$ | async"
                    [addTag]="false"
                    [multiple]="true"
                    [hideSelected]="true"
                    [trackByFn]="trackByFn"
                    [loading]="clientLoading"
                    [typeahead]="clientInput$"
                    [(ngModel)]="selectedClients"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="onClientSelect()"
                  >
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                      <span
                        class="ng-value-icon right"
                        (click)="clear(item)"
                        aria-hidden="true"
                        >×</span
                      >
                      <span>
                        {{ item.business_name }}
                        <small *ngIf="item.user">
                          {{ item.user.firstname }} {{ item.user.lastname }}
                        </small>
                      </span>
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      <h6>
                        {{ item.business_name }}
                        <small *ngIf="item.user">
                          {{ item.user.firstname }} {{ item.user.lastname }}
                        </small>
                      </h6>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="">Invoice #</label>
                  <ng-select
                    [items]="invoices$ | async"
                    [addTag]="false"
                    [multiple]="true"
                    [hideSelected]="true"
                    [trackByFn]="trackByFn"
                    [loading]="invoiceLoading$ | async"
                    [typeahead]="invoiceInput$"
                    [(ngModel)]="selectedInvoices"
                    [ngModelOptions]="{ standalone: true }"
                    (change)="onInvoiceSelect()"
                  >
                    <ng-template ng-label-tmp let-item="item" let-clear="clear">
                      <span
                        class="ng-value-icon right"
                        (click)="clear(item)"
                        aria-hidden="true"
                        >×</span
                      >
                      <span> Invoice #{{ item.id }} </span>
                    </ng-template>
                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-index="index"
                      let-search="searchTerm"
                    >
                      <h6>Invoice #{{ item.id }}</h6>
                    </ng-template>
                  </ng-select>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label>Street Address 1</label>
                  <input
                    [readonly]="
                      formData.controls.default_ship_to_address.value == 'warehouse'
                    "
                    type="text"
                    class="form-control"
                    formControlName="street_address_1"
                  />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label>Street Address 2</label>
                  <input
                    [readonly]="
                      formData.controls.default_ship_to_address.value == 'warehouse'
                    "
                    type="text"
                    class="form-control"
                    formControlName="street_address_2"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-5">
                <div class="form-group">
                  <label for="">City</label>
                  <input
                    [readonly]="
                      formData.controls.default_ship_to_address.value == 'warehouse'
                    "
                    type="text"
                    class="form-control"
                    formControlName="city"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="">State</label>
                  <input
                    [readonly]="
                      formData.controls.default_ship_to_address.value == 'warehouse'
                    "
                    type="text"
                    class="form-control"
                    formControlName="state"
                  />
                </div>
              </div>
              <div class="col-md-2">
                <div class="form-group">
                  <label for="">Zip</label>
                  <input
                    [readonly]="
                      formData.controls.default_ship_to_address.value == 'warehouse'
                    "
                    type="text"
                    class="form-control"
                    formControlName="zip"
                  />
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label for="">Country</label>
                  <input
                    [readonly]="
                      formData.controls.default_ship_to_address.value == 'warehouse'
                    "
                    type="text"
                    class="form-control"
                    formControlName="country"
                  />
                </div>
              </div>
            </div>
            <!-- Custom Fields Section -->
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <label>Custom Fields</label>
                  <div class="lum-c-purchase-order-inline-form__custom-fields">
                    <ng-container *ngIf="!loadingCustomFields; else customFieldsLoading">
                      <lum-custom-field-form-group
                        [customFieldObject]="eCustomFieldObject.SUPPLIER_PURCHASE_ORDER"
                        [customFieldValues]="purchaseOrder?.custom_field_values || []"
                        [formCustomFieldValues]="customFieldFormValuesJson"
                        (onChange)="onCustomFieldValuesChange($event)"
                        view="table"
                      ></lum-custom-field-form-group>
                    </ng-container>
                    <ng-template #customFieldsLoading>
                      <div class="form-group">
                        <mat-progress-spinner
                          class="lum-c-purchase-order-inline-form__progress-spinner"
                          diameter="24"
                          mode="indeterminate"
                        ></mat-progress-spinner>
                        <small>Loading custom fields...</small>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>

            <div class="clearfix"></div>
            <div class="action-button">
              <button
                type="button"
                class="btn btn-outline-info"
                (click)="activeTab = 1"
                [translate]="'BUTTONS.NEXT'"
                [disabled]="formData.invalid"
              >
                Next <i class="ml-1 fas fa-arrow-right"></i>
              </button>
            </div>
          </mat-tab>

          <mat-tab label="Add Purchase Order Items" [disabled]="formData.invalid">
            <mat-tab-group
              mat-align-tabs="start"
              *ngIf="activeTab === 1 && loadingUomRules === false; else loader"
              [selectedIndex]="0"
            >
              <mat-tab label="SKUs">
                <div class="po-items overflow-auto" formArrayName="po_items">
                  <div class="d-flex justify-content-between align-items-end mb-4">
                    <div class="col-md-4">
                      <cnc-line-items-multiselect
                        (selectItemsEvent)="onMultiselectItems($event)"
                        [excludeKits]="true"
                        [skusOnly]="true"
                        [supplierId]="formData.value.factory_id"
                        [warehouseId]="warehouseId"
                        [forPoForm]="true"
                      ></cnc-line-items-multiselect>
                    </div>
                    <div class="">
                      <button
                        class="btn btn-outline-info mr-2 mt-1"
                        type="button"
                        mat-raised-button
                        color="primary"
                        (click)="createRfqForClient()"
                        [ngClass]="{
                          'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':
                            loading,
                          'disable-click': isAuthAndTotalPaid,
                        }"
                      >
                        <i class="fas fa-plus"></i> Add New SKU
                      </button>
                      <button
                        class="btn btn-outline-success mr-2 mt-1"
                        type="button"
                        mat-raised-button
                        color="primary"
                        (click)="addVariantSku()"
                        [ngClass]="{
                          'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':
                            loading,
                          'disable-click': isAuthAndTotalPaid,
                        }"
                      >
                        <i class="fas fa-plus"></i> Add New Variant SKU
                      </button>
                      <button
                        class="btn btn-outline-success mt-1"
                        type="button"
                        mat-raised-button
                        color="primary"
                        (click)="onAddMultipleLineItems()"
                        [ngClass]="{
                          'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':
                            loading,
                          'disable-click': isAuthAndTotalPaid,
                        }"
                      >
                        <i class="fas fa-plus"></i> Quick Add
                      </button>
                    </div>

                    <div class="form-group mb-0">
                      <label>
                        Upload
                        <small class="text-muted">
                          <span class="upload-label"
                            >(<a (click)="downloadTemplate()">Download Template</a
                            >)</span
                          >
                        </small></label
                      >
                      <input
                        type="file"
                        class="form-control"
                        (change)="onFileUpload($event)"
                      />
                    </div>
                  </div>

                  <div class="d-flex justify-content-end mb-5">
                    <div ngbDropdown container="body" placement="bottom-right">
                      <button
                        class="btn btn-sm btn-info btn-block"
                        id="dropdownBasic3"
                        ngbDropdownToggle
                        *ngIf="canBulkUpdate()"
                      >
                        Bulk Update
                      </button>
                      <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
                        <button
                          ngbDropdownItem
                          (click)="bulkUpdate(lineItemFormField.QUANTITY)"
                        >
                          Bulk Update Quantity
                        </button>
                        <button
                          ngbDropdownItem
                          (click)="bulkUpdate(lineItemFormField.PRICE)"
                        >
                          Bulk Update Cost
                        </button>
                        <button
                          ngbDropdownItem
                          (click)="bulkUpdate(lineItemFormField.DOWNPAYMENT)"
                        >
                          Bulk Update Downpayment
                        </button>
                      </div>
                    </div>
                  </div>

                  <table
                    class="table table-striped line-items-table"
                    [ngClass]="{
                      'disabledSourceSkuDescription-table':
                        !showSupplierPoSourceSkuSetting ||
                        !showSupplierPoDescriptionSetting,
                    }"
                  >
                    <thead>
                      <th class="px-3 disabledSourceSkuDescription-col-w50">
                        <mat-checkbox
                          color="primary"
                          [(ngModel)]="checkedAll.po_items"
                          (ngModelChange)="updateCheckedItems()"
                          [ngModelOptions]="{ standalone: true }"
                        >
                        </mat-checkbox>
                      </th>
                      <th class="disabledSourceSkuDescription-col-w50"></th>
                      <th
                        class="lum-c-purchase-order-inline-form__table-col--variants px-2"
                      ></th>
                      <th class="lum-c-purchase-order-inline-form__table-col--sku">
                        SKU
                      </th>
                      <th
                        class="lum-c-purchase-order-inline-form__table-col--products"
                      >
                        Products
                      </th>
                      <th *ngIf="showSupplierPoSourceSkuSetting">Source SKU</th>
                      <th *ngIf="showSupplierPoDescriptionSetting">
                        Description
                      </th>
                      <th class="w-25">Qty</th>
                      <th>UOM <span class="text-danger">*</span></th>
                      <th *ngxPermissionsOnly="['skuUnitCost.read']" class="w-25"
                        >Unit Cost</th
                      >
                      <th
                        *ngIf="
                          !(
                            'red_DV-2659_fifo_landed_cost_multiple_shipments'
                            | featureFlag
                          )
                        "
                      >
                        Downpayment
                      </th>
                      <th *ngxPermissionsOnly="['skuUnitCost.read']" class="w-30"
                        >Line Total</th
                      >
                      <th class="disabledSourceSkuDescription-col-w50"> &nbsp; </th>
                    </thead>
                    <tbody
                      id="purchase-order-line-items"
                      cdkDropList
                      (cdkDropListDropped)="drop($event)"
                      class="drag-boundary"
                    >
                      <ng-container
                        *ngFor="
                          let item of poItemsFormArray['controls'];
                          let idx = index
                        "
                      >
                        <tr
                          [cdkDropList]="formData.value.po_items"
                          [formGroupName]="idx"
                          cdkDrag
                          cdkDragLockAxis="y"
                          cdkDragBoundary=".drag-boundary"
                          id="row-order{{ idx }}"
                        >
                          <div
                            class="drag-and-drop-placeholder"
                            *cdkDragPlaceholder
                          ></div>
                          <td class="vertical-align-center">
                            <mat-checkbox
                              class="px-3 py-2"
                              color="primary"
                              formControlName="checked"
                              [cncKeyPressLineItems]="{
                                key: getKey(0, idx, 'row-order' + idx),
                                parentId: 'purchase-order-line-items',
                                rowClass: 'row-order' + idx,
                              }"
                            >
                            </mat-checkbox>
                          </td>
                          <td class="vertical-align-center">
                            <span class="drag-icon" cdkDragHandle>
                              <i class="fa fa-bars"></i>
                            </span>
                          </td>
                          <td
                            class="lum-c-purchase-order-inline-form__table-col--variants"
                          >
                            <span
                              *ngIf="
                                item.value?.product_variants?.length > 0 &&
                                item.value?.is_product_variant
                              "
                              [matTooltip]="
                                showProductVariants[idx]
                                  ? 'Hide Product Variants'
                                  : 'Show Product Variants'
                              "
                              class="toggle-icon"
                              (click)="
                                showProductVariants[idx] = !showProductVariants[idx]
                              "
                            >
                              <i
                                class="fas"
                                [ngClass]="{
                                  'fa-chevron-down': !showProductVariants[idx],
                                  'fa-chevron-up': showProductVariants[idx],
                                }"
                              ></i>
                            </span>
                          </td>
                          <td
                            class="lum-c-purchase-order-inline-form__table-col--sku"
                            [ngStyle]="
                              !showSupplierPoSourceSkuSetting ||
                              !showSupplierPoDescriptionSetting
                                ? {}
                                : { width: '150px', maxWidth: '150px' }
                            "
                          >
                            {{ item && item.value.rfq ? item.value.rfq.sku : '' }}
                          </td>
                          <td
                            class="lum-c-purchase-order-inline-form__table-col--products"
                            [ngStyle]="
                              !showSupplierPoSourceSkuSetting ||
                              !showSupplierPoDescriptionSetting
                                ? {}
                                : { width: '300px', maxWidth: '300px' }
                            "
                          >
                            <cnc-sku-kit-dropdown
                              controlName="rfq"
                              (selectedItem)="onSelectedSKUItem(idx, $event)"
                              [isRfqs]="true"
                              [isKits]="false"
                              [rfqType]="productTypes.PRODUCT"
                              [isPurchaseOrder]="true"
                              [matTooltip]="showTooltip(item)"
                              [matTooltipDisabled]="!showTooltip(item)"
                              [matTooltipShowDelay]="1000"
                              [addTag]="false"
                              matTooltipPosition="above"
                              [itemRowId]="'itemRowId' + idx"
                              [excludeKits]="true"
                              [supplierId]="formData.value.factory_id"
                              [warehouseId]="warehouseId"
                              [cncKeyPressLineItems]="{
                                key: getKey(1, idx, 'row-order' + idx),
                                parentId: 'purchase-order-line-items',
                                rowClass: 'row-order' + idx,
                              }"
                              [forPoForm]="true"
                            ></cnc-sku-kit-dropdown>
                          </td>
                          <td *ngIf="showSupplierPoSourceSkuSetting">
                            <input
                              type="text"
                              class="form-control source-sku"
                              formControlName="source_sku"
                              [cncKeyPressLineItems]="{
                                key: getKey(2, idx, 'row-order' + idx),
                                parentId: 'purchase-order-line-items',
                                rowClass: 'row-order' + idx,
                              }"
                            />
                          </td>
                          <td *ngIf="showSupplierPoDescriptionSetting">
                            <input
                              type="text"
                              class="form-control source-sku"
                              formControlName="description"
                              [cncKeyPressLineItems]="{
                                key: getKey(3, idx, 'row-order' + idx),
                                parentId: 'purchase-order-line-items',
                                rowClass: 'row-order' + idx,
                              }"
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              class="form-control text-right"
                              formControlName="quantity"
                              (change)="computeTotal(idx)"
                              [cncKeyPressLineItems]="{
                                key: getKey(
                                  !showSupplierPoSourceSkuSetting ||
                                    !showSupplierPoDescriptionSetting
                                    ? 2
                                    : 4,
                                  idx,
                                  'row-order' + idx
                                ),
                                parentId: 'purchase-order-line-items',
                                rowClass: 'row-order' + idx,
                              }"
                              lumDecimalLimit
                            />
                          </td>
                          <td>
                            <ng-select
                              [appendTo]="'body'"
                              [items]="
                                formData.value.po_items[idx] &&
                                formData.value.po_items[idx].rfq
                                  ? unitOfMeasures[
                                      formData.value.po_items[idx].rfq.id
                                    ]
                                  : []
                              "
                              formControlName="ordered_uom_id"
                              bindValue="id"
                              bindLabel="name"
                              [multiple]="false"
                              [clearable]="false"
                              (change)="computeTotal(idx)"
                              [cncKeyPressLineItems]="{
                                key: getKey(
                                  !showSupplierPoSourceSkuSetting ||
                                    !showSupplierPoDescriptionSetting
                                    ? 3
                                    : 5,
                                  idx,
                                  'row-order' + idx
                                ),
                                parentId: 'purchase-order-line-items',
                                rowClass: 'row-order' + idx,
                              }"
                              [isOpen]="isOpen[idx]"
                              (focus)="isOpen[idx] = true"
                              (blur)="isOpen[idx] = false"
                              (open)="isOpen[idx] = true"
                              [class]="{
                                'uom-dropdown': poItemsFormArray
                                  .at(idx)
                                  .get('ordered_uom_id').errors,
                              }"
                            >
                            </ng-select>
                          </td>
                          <td *ngxPermissionsOnly="['skuUnitCost.read']">
                            <input
                              type="number"
                              class="form-control text-right"
                              formControlName="unit_price"
                              (change)="onUnitPriceChange(idx)"
                              [cncKeyPressLineItems]="{
                                key: getKey(
                                  !showSupplierPoSourceSkuSetting ||
                                    !showSupplierPoDescriptionSetting
                                    ? 4
                                    : 6,
                                  idx,
                                  'row-order' + idx
                                ),
                                parentId: 'purchase-order-line-items',
                                rowClass: 'row-order' + idx,
                              }"
                            />
                          </td>
                          <td
                            *ngIf="
                              !(
                                'red_DV-2659_fifo_landed_cost_multiple_shipments'
                                | featureFlag
                              )
                            "
                          >
                            <input
                              type="number"
                              class="form-control text-right"
                              formControlName="downpayment_amount"
                              (change)="computeTotal(idx)"
                              [cncKeyPressLineItems]="{
                                key: getKey(
                                  !showSupplierPoSourceSkuSetting ||
                                    !showSupplierPoDescriptionSetting
                                    ? 5
                                    : 7,
                                  idx,
                                  'row-order' + idx
                                ),
                                parentId: 'purchase-order-line-items',
                                rowClass: 'row-order' + idx,
                              }"
                            />
                          </td>
                          <td *ngxPermissionsOnly="['skuUnitCost.read']">
                            <input
                              type="number"
                              class="form-control text-right"
                              formControlName="line_total"
                              lumDecimalLimit
                              lumDebounceTime
                              (change)="onLineItemChange(idx)"
                            />
                          </td>
                          <td>
                            <a class="text-danger p-3" (click)="removeItemRow(idx)">
                              <i class="fas fa-times"></i>
                            </a>
                          </td>
                        </tr>

                        <tr
                          *ngIf="
                            item.value?.product_variants?.length > 0 &&
                            showProductVariants[idx] &&
                            item.value?.is_product_variant
                          "
                        >
                          <td colspan="4" class="pl-3"></td>
                          <td colspan="10">
                            <table class="w-100">
                              <thead>
                                <th
                                  *ngFor="
                                    let variant of item.value?.product_variants
                                  "
                                  class="px-3"
                                >
                                  {{ variant.name }}
                                </th>
                              </thead>
                              <tbody>
                                <tr>
                                  <ng-container
                                    *ngFor="
                                      let variant of item.value?.product_variants
                                    "
                                  >
                                    <td
                                      *ngFor="let term of variant.variant_terms"
                                      class="px-3"
                                    >
                                      {{ term }}
                                    </td>
                                  </ng-container>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td
                          [attr.colspan]="
                            !showSupplierPoSourceSkuSetting ||
                            !showSupplierPoDescriptionSetting
                              ? '3'
                              : '5'
                          "
                          class="text-right"
                        >
                          TOTAL
                        </td>

                        <td class="text-right">
                          {{ total.quantity | decimalPlaces }}
                        </td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td
                          *ngxPermissionsOnly="['skuUnitCost.read']"
                          class="text-right"
                        >
                          {{ total.amount | lumCurrency }}
                        </td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr>
                        <td colspan="11" class="text-center">
                          <div ngbDropdown placement="top-right" container="body">
                            <button
                              class="lum-button lum-button--dotted lum-button--full-width"
                              id="dropdownBasic2"
                              ngbDropdownToggle
                            >
                              Add Item(s)
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                              <button
                                *ngFor="let rows of [1, 5, 10, 25, 50]"
                                ngbDropdownItem
                                (click)="addMultipleLineItemRows(rows)"
                              >
                                Add {{ rows }}
                                {{ rows > 1 ? 'Items' : 'Item' }}
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </mat-tab>
              <mat-tab label="Additional Fees">
                <div class="d-flex justify-content-end mb-5">
                  <div ngbDropdown container="body" placement="bottom-right">
                    <button
                      class="btn btn-sm btn-info btn-block"
                      id="dropdownBasic3"
                      ngbDropdownToggle
                      *ngIf="canBulkUpdate(true)"
                    >
                      Bulk Update
                    </button>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic3">
                      <button
                        ngbDropdownItem
                        (click)="bulkUpdate(lineItemFormField.QUANTITY, true)"
                      >
                        Bulk Update Quantity
                      </button>
                      <button
                        ngbDropdownItem
                        (click)="bulkUpdate(lineItemFormField.PRICE, true)"
                      >
                        Bulk Update Cost
                      </button>
                      <button
                        ngbDropdownItem
                        (click)="bulkUpdate(lineItemFormField.DOWNPAYMENT, true)"
                      >
                        Bulk Update Downpayment
                      </button>
                    </div>
                  </div>
                </div>
                <div class="po-items overflow-auto" formArrayName="po_custom_items">
                  <table class="table table-striped line-items-table">
                    <thead>
                      <th class="px-3">
                        <mat-checkbox
                          color="primary"
                          [(ngModel)]="checkedAll.po_custom_items"
                          (ngModelChange)="updateCheckedItems(true)"
                          [ngModelOptions]="{ standalone: true }"
                        >
                        </mat-checkbox>
                      </th>
                      <th>&nbsp;</th>
                      <th>Item</th>
                      <th>Qty</th>
                      <th>Unit Cost</th>
                      <th
                        *ngIf="
                          !(
                            'red_DV-2659_fifo_landed_cost_multiple_shipments'
                            | featureFlag
                          )
                        "
                      >
                        Downpayment
                      </th>
                      <th>Line Total</th>
                      <th
                        *ngIf="
                          !(this.purchaseOrder && this.purchaseOrder.total_paid > 0)
                        "
                      >
                        &nbsp;
                      </th>
                    </thead>
                    <tbody
                      cdkDropList
                      (cdkDropListDropped)="drop($event, true)"
                      class="drag-boundary"
                    >
                      <tr
                        *ngFor="
                          let item of formData['controls'].po_custom_items[
                            'controls'
                          ];
                          let idx = index
                        "
                        [formGroupName]="idx"
                        cdkDrag
                        cdkDragLockAxis="y"
                        cdkDragBoundary=".drag-boundary"
                        class="other-line-items-row"
                      >
                        <div
                          class="drag-and-drop-placeholder"
                          *cdkDragPlaceholder
                        ></div>
                        <td class="vertical-align-center">
                          <mat-checkbox
                            class="px-3 py-2"
                            color="primary"
                            formControlName="checked"
                          >
                          </mat-checkbox>
                        </td>
                        <td class="vertical-align-center">
                          <span class="drag-icon" cdkDragHandle>
                            <i class="fa fa-bars"></i>
                          </span>
                        </td>
                        <td width="40%" class="pr-5">
                          <input
                            type="text"
                            class="form-control source-sku"
                            formControlName="product_name"
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            class="form-control text-right"
                            formControlName="quantity"
                            (change)="computeCustomItemTotal(idx)"
                            lumDecimalLimit
                          />
                        </td>
                        <td>
                          <input
                            type="number"
                            class="form-control text-right"
                            formControlName="unit_price"
                            (change)="computeCustomItemTotal(idx)"
                          />
                        </td>
                        <td
                          *ngIf="
                            !(
                              'red_DV-2659_fifo_landed_cost_multiple_shipments'
                              | featureFlag
                            )
                          "
                        >
                          <input
                            type="number"
                            class="form-control text-right"
                            formControlName="downpayment_amount"
                            (change)="computeCustomItemTotal(idx)"
                          />
                        </td>
                        <td>
                          <span class="form-control">
                            {{
                              formData.value.po_custom_items[idx].line_total
                                | lumCurrency
                            }}
                          </span>
                        </td>
                        <td>
                          <a
                            class="text-danger p-3"
                            (click)="removeCustomItemRow(idx)"
                          >
                            <i class="fas fa-times"></i>
                          </a>
                        </td>
                      </tr>
                    </tbody>

                    <tfoot>
                      <tr>
                        <td colspan="3" class="text-right">TOTAL</td>

                        <td class="text-right">
                          {{ custom_item_total.quantity | decimalPlaces }}
                        </td>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                        <td class="text-right">
                          {{ custom_item_total.amount | lumCurrency }}
                        </td>
                        <td>&nbsp;</td>
                      </tr>
                      <tr>
                        <td colspan="8" class="text-center">
                          <div ngbDropdown placement="top-right" container="body">
                            <button
                              class="lum-button lum-button--dotted lum-button--full-width"
                              id="dropdownBasic2"
                              ngbDropdownToggle
                            >
                              Add Item(s)
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic2">
                              <button
                                *ngFor="let rows of [1, 5, 10, 25, 50]"
                                ngbDropdownItem
                                (click)="addMultipleLineItemRows(rows, true)"
                              >
                                Add {{ rows }}
                                {{ rows > 1 ? 'Items' : 'Item' }}
                              </button>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </mat-tab>
            </mat-tab-group>

            <div class="clearfix"></div>
            <div class="action-button">
              <button
                type="button"
                class="btn btn-outline-secondary"
                (click)="activeTab = 0"
                [translate]="'BUTTONS.BACK'"
              >
                <i class="fas fa-arrow-left"></i> Back
              </button>
              <button
                type="button"
                class="btn btn-outline-secondary ml-1"
                (click)="activeTab = 2"
                [translate]="'BUTTONS.NEXT'"
                [disabled]="formData.invalid || formData.value.po_items.length == 0"
              >
                Next <i class="ml-1 fas fa-arrow-right"></i>
              </button>
            </div>
          </mat-tab>

          <mat-tab
            label="Review and Save"
            [disabled]="formData.invalid || formData.value.po_items.length == 0"
          >
            <div class="form-group">
              <label>Tags</label>
              <ng-select
                [items]="tags"
                formControlName="tags"
                bindValue="id"
                [searchFn]="customTagsSearchFn"
                multiple="true"
              >
                <ng-template ng-label-tmp let-item="item" let-clear="clear">
                  <span
                    class="ng-value-icon right"
                    (click)="clear(item)"
                    aria-hidden="true"
                    >×</span
                  >
                  <span [innerHTML]="item.name" class="d-inline"></span>
                </ng-template>
                <ng-template
                  ng-option-tmp
                  let-item="item"
                  let-index="index"
                  let-search="searchTerm"
                >
                  <h6 [innerHTML]="item.name"></h6>
                </ng-template>
              </ng-select>
            </div>

            <div *ngIf="activeFactory">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Supplier</label>
                    <h4>{{ activeFactory.factory_name }}</h4>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Incoterm</label>
                    <h4>{{ logistics[this.formData.value.logistic] }}</h4>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Order Type</label>
                    <h5 *ngIf="formData.value.order_type == 1">Bulk Order</h5>
                    <h5 *ngIf="formData.value.order_type == 10"> Sample Order </h5>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Payment Terms</label>
                    <h5>{{ formData.value.payment_terms }}</h5>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Tracking Info</label>
                    <h5>{{ formData.value.tracking_info }}</h5>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="">Order Date</label>
                    <h5>
                      {{ formData.value.order_date | date: 'mediumDate' }}
                    </h5>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="">Requested Ship Date</label>
                    <h5>
                      {{ formData.value.requested_ship_date | date: 'mediumDate' }}
                    </h5>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="">Arrival Due Date</label>
                    <h5>
                      {{ formData.value.arrival_due_date | date: 'mediumDate' }}
                    </h5>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="">Invoice Date</label>
                    <h5>
                      {{ formData.value.invoice_date | date: 'mediumDate' }}
                    </h5>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="">Alternate ID</label>
                    <h5>
                      <span
                        class="kt-badge kt-badge--primary kt-badge--outline kt-badge--pill"
                        *ngFor="let alternateId of alternateIds"
                      >
                        {{ alternateId }}
                      </span>
                    </h5>
                  </div>
                </div>
              </div>

              <ng-container>
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="" class="d-block">Clients</label>
                      <h6
                        *ngFor="let client of selectedClients; last as isLast"
                        class="d-inline-block"
                      >
                        {{ client?.business_name }}
                        <span *ngIf="client.user">
                          {{ client?.user?.firstname }}
                          {{ client?.user?.lastname }}
                        </span>
                        <span *ngIf="!isLast">,&nbsp;</span>
                      </h6>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label for="" class="d-block">Invoices</label>
                      <h6
                        *ngFor="let invoice of selectedInvoices; last as isLast"
                        class="d-inline-block"
                      >
                        Invoice #{{ invoice.id }}
                        <span *ngIf="!isLast">,&nbsp;</span>
                      </h6>
                    </div>
                  </div>
                </div>
              </ng-container>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Private Note</label>
                    <h5>{{ formData.value.private_note }}</h5>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Public Note</label>
                    <h5>{{ formData.value.public_note }}</h5>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="">Ship to Address</label>
                    <h5>
                      <span>{{ formData.value.street_address_1 }} </span>
                      <span>{{ formData.value.street_address_2 }} </span>
                      <span>{{ formData.value.city }} </span>
                      <span>{{ formData.value.state }} </span>
                      <span>{{ formData.value.zip }} </span>
                      <span>{{ formData.value.country }}</span>
                    </h5>
                  </div>
                </div>
              </div>

              <!-- Custom Fields Section -->
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label>Custom Fields</label>
                    <div class="lum-c-purchase-order-inline-form__custom-fields">
                      <ng-container *ngIf="!loadingCustomFields; else customFieldsLoading">
                        <lum-custom-field-value-details
                          [customFieldValues]="displayCustomFieldValues"
                          view="table"
                        ></lum-custom-field-value-details>
                      </ng-container>
                      <ng-template #customFieldsLoading>
                        <div class="form-group">
                          <mat-progress-spinner
                            class="lum-c-purchase-order-inline-form__progress-spinner"
                            diameter="24"
                            mode="indeterminate"
                          ></mat-progress-spinner>
                          <small>Loading custom fields...</small>
                        </div>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>

              <h4>Order Items</h4>
              <table class="table table-striped">
                <thead>
                  <th>SKU Product</th>
                  <th *ngIf="showSupplierPoSourceSkuSetting" width="200px">
                    Source SKU
                  </th>
                  <th *ngIf="showSupplierPoDescriptionSetting" width="200px">
                    Description
                  </th>
                  <th width="150px" class="text-right">Qty</th>
                  <th width="150px" class="text-right">UOM</th>
                  <th
                    *ngxPermissionsOnly="['skuUnitCost.read']"
                    width="150px"
                    class="text-right"
                    >Unit Cost</th
                  >
                  <th
                    width="150px"
                    class="text-right"
                    *ngIf="
                      !(
                        'red_DV-2659_fifo_landed_cost_multiple_shipments'
                        | featureFlag
                      )
                    "
                  >
                    Downpayment
                  </th>
                  <th
                    *ngxPermissionsOnly="['skuUnitCost.read']"
                    width="150px"
                    class="text-right"
                    >Line Total</th
                  >
                  <th width="50px">&nbsp;</th>
                </thead>
                <tbody>
                  <tr *ngFor="let item of formData.value.po_items; let i = index">
                    <ng-container *ngIf="item.rfq && item.rfq.id">
                      <td>
                        <span *ngIf="item.rfq.sku && item.rfq.sku.length > 3">
                          [{{ item.rfq.sku }}]
                        </span>
                        {{ item.rfq.product_name }}
                      </td>
                      <td *ngIf="showSupplierPoSourceSkuSetting">
                        {{ item?.source_sku }}
                      </td>
                      <td *ngIf="showSupplierPoDescriptionSetting">
                        {{ item?.description }}
                      </td>
                      <td class="text-right">
                        {{ item.quantity | decimalPlaces }}
                      </td>
                      <td class="text-right">
                        {{ getUnitMeasure(i) }}
                      </td>
                      <td
                        *ngxPermissionsOnly="['skuUnitCost.read']"
                        class="text-right"
                      >
                        {{ item.unit_price | lumCurrency }}
                      </td>
                      <td
                        class="text-right"
                        *ngIf="
                          !(
                            'red_DV-2659_fifo_landed_cost_multiple_shipments'
                            | featureFlag
                          )
                        "
                      >
                        {{ item.downpayment_amount | lumCurrency }}
                      </td>
                      <td
                        *ngxPermissionsOnly="['skuUnitCost.read']"
                        class="text-right"
                      >
                        {{ item.line_total | lumCurrency }}
                      </td>
                      <td>
                        <a class="text-danger" (click)="removeItemRow(i)">
                          <i class="fas fa-times"></i>
                        </a>
                      </td>
                    </ng-container>
                  </tr>
                </tbody>
                <!-- <tfoot>
							<tr>
								<td class="text-right">TOTAL</td>
								<td>&nbsp;</td>
								<td class="text-right">
									{{ total.quantity }}
								</td>
								<td>&nbsp;</td>
								<td class="text-right">
									{{ total.amount | currency: "":"symbol":"1.2-4" }}
								</td>
								<td>&nbsp;</td>
							</tr>
							<tr *ngIf="purchaseOrder && purchaseOrder.total_shipping_cost > 0">
								<td class="text-right text-warning">TOTAL SHIPPING COST</td>
								<td>&nbsp;</td>
								<td class="text-right">&nbsp;</td>
								<td>&nbsp;</td>
								<td class="text-right text-warning">
									{{ purchaseOrder.total_shipping_cost | currency: "":"symbol":"1.2-4" }}
								</td>
								<td>&nbsp;</td>
							</tr>
						</tfoot> -->
              </table>

              <div
                *ngIf="
                  formData.value.po_custom_items &&
                  formData.value.po_custom_items.length > 0
                "
              >
                <h5>Additional Fees/Items</h5>
                <table class="table table-striped">
                  <thead>
                    <th>Item Name</th>
                    <th width="200px">&nbsp;</th>
                    <th width="150px" class="text-right">Qty</th>
                    <th width="150px" class="text-right">Unit Cost</th>
                    <th width="150px" class="text-right">Line Total</th>
                    <th width="50px">&nbsp;</th>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="
                        let item of formData.value.po_custom_items;
                        let i = index
                      "
                    >
                      <ng-container *ngIf="item && item.product_name">
                        <td>
                          {{ item.product_name }}
                        </td>
                        <td>&nbsp;</td>
                        <td class="text-right">
                          {{ item.quantity | decimalPlaces }}
                        </td>
                        <td class="text-right">
                          {{ item.unit_price | lumCurrency }}
                        </td>
                        <td class="text-right">
                          {{ item.line_total | lumCurrency }}
                        </td>
                        <td>
                          <a class="text-danger" (click)="removeCustomItemRow(i)">
                            <i class="fas fa-times"></i>
                          </a>
                        </td>
                      </ng-container>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr>
                      <td class="text-right">TOTAL</td>
                      <td>&nbsp;</td>
                      <td class="text-right">
                        {{
                          total.quantity + custom_item_total.quantity
                            | decimalPlaces
                        }}
                      </td>
                      <td>&nbsp;</td>
                      <td class="text-right">
                        {{ total.amount + custom_item_total.amount | lumCurrency }}
                      </td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr
                      *ngIf="purchaseOrder && purchaseOrder.total_shipping_cost > 0"
                    >
                      <td class="text-right text-warning"> TOTAL SHIPPING COST </td>
                      <td>&nbsp;</td>
                      <td class="text-right">&nbsp;</td>
                      <td>&nbsp;</td>
                      <td class="text-right text-warning">
                        {{ purchaseOrder.total_shipping_cost | lumCurrency }}
                      </td>
                      <td>&nbsp;</td>
                    </tr>
                  </tfoot>
                </table>
              </div>
            </div>

            <div class="clearfix"></div>
            <div class="action-button row">
              <div class="col-md-4">
                <button
                  type="button"
                  class="btn btn-outline-secondary"
                  (click)="activeTab = 1"
                  [translate]="'BUTTONS.BACK'"
                >
                  <i class="fas fa-arrow-left"></i> Back
                </button>
              </div>
              <div class="col-md-8 text-right">
                <button
                  type="button"
                  [ngClass]="{
                    'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light':
                      loading,
                  }"
                  [disabled]="loading"
                  id="kt_submit"
                  class="btn btn-primary ml-1"
                  (click)="confirmOrder()"
                >
                  <span *ngIf="!isUpdate">
                    <i class="fas fa-plus"></i> Create Order
                  </span>
                  <span *ngIf="isUpdate">
                    <i class="fas fa-check"></i> Update Order
                  </span>
                </button>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>

      <div class="kt-portlet__body" *ngIf="isPageLoad">
        <div class="is-loading">
          <mat-spinner [diameter]="32"></mat-spinner>
        </div>
      </div>
    </div>
  </div>
</form>
